import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';
import { Button } from '../buttons';

export const GratitudeButton = styled(Button)(
	({ theme }: { theme: Theme }) => theme.offlineChat.buttons.gratitudeButton
);
